import {
  Pagination as RaPagination,
  PaginationProps as RaPaginationProps,
  useListContext,
} from 'react-admin';

export type PaginationProps = RaPaginationProps;

export const Pagination: React.FC<PaginationProps> = (props) => {
  const { total } = useListContext();
  if (!total) {
    return <></>;
  }
  return <RaPagination {...props} />;
};
